/**
 * Получает поле из связанной сущности Directus
 * Связанные сущности могут быть представлены как number | InstanceType | null
 */
export function getRelatedField<T extends Record<string, unknown>>(
  entity: number | T | null | unknown,
  field: keyof T
): T[typeof field] | null {
  if (entity === null || typeof entity === "number") {
    return null;
  }
  if (typeof entity === "object" && entity !== null && field in entity) {
    return (entity as T)[field] as T[typeof field];
  }
  return null;
}
